import React from 'react';
import './MiniGenderProgressChart.css';

const MiniGenderProgressChart = ({
  maleValue = 500,
  femaleValue = 200,
  totalValue = 3000,
}) => {
  const malePercentage = totalValue ? (maleValue / totalValue) * 100 : 0;
  const femalePercentage = totalValue ? (femaleValue / totalValue) * 100 : 0;

  return (
    <div className="mini-gender-progress-container">
      <div className="mini-single-progress-container">
        {/* 背景 */}
        <div className="mini-progress-bg mini-male-bg" />
        <div className="mini-progress-bg mini-female-bg" />

        {/* 男性条 */}
        <div
          className="mini-progress-segment mini-male-segment"
          style={{ width: `${malePercentage}%` }}
        />

        {/* 女性条 */}
        <div
          className="mini-progress-segment mini-female-segment"
          style={{ width: `${femalePercentage}%` }}
        />

        {/* 男标签 */}
        <div className="mini-label mini-male-label">
          {maleValue}人 ({malePercentage.toFixed(1)}%)
        </div>

        {/* 女标签 */}
        <div className="mini-label mini-female-label">
          {femaleValue}人 ({femalePercentage.toFixed(1)}%)
        </div>

        {/* 中线 */}
        <div className="mini-segment-divider" />
      </div>
    </div>
  );
};

export default MiniGenderProgressChart;
